export const TICKETS_TYPES = {
  MARKET: 7,
  FUEL: -1,
  GNV: 6,
  CREDIT: 10
}


export const STYLES_TIRILLA = `
    <style>
      @media print {
        body {
          font-family: monospace;
          margin: 0 !important;
          padding: 0 !important;
          font-weight: 700;
          font-stretch: condensed;
          -webkit-font-stretch: condensed;
          font-variant-numeric: tabular-nums;
          letter-spacing: -0.2px;
        }

        .receipt-container {
          page-break-inside: avoid;
          break-inside: avoid;
        }

        .receipt {
          width: 80mm;
          background-color: white;
          font-size: 10px;
          
          font-weight: 400;
          font-stretch: condensed;
          -webkit-font-stretch: condensed;
          font-variant-numeric: tabular-nums;
          page-break-inside: avoid !important;
          break-inside: avoid !important;
          align-items: start !important;
        }

        .receipt:last-child {
          border-bottom: none;
          margin-bottom: 0;
          padding-bottom: 0;
        }

        .receipt p {
          font-size: 10px;
          margin: 0;
          padding: 0;
          line-height: 2;
        }

        .img__logo__tirilla {
          height: 4rem;
          margin: 18px;
          width: 80mm;
        }

        .img__qr__tirilla {
          width: 60%;
        }

        .receipt__container__cufe {
          word-wrap: break-word;
          overflow-wrap: break-word;
          white-space: normal;
        }

        .receipt__container__qr {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
        }

        .receipt__preview-container {
          padding: 1.8rem;
          background-color: #f0f0f0;
          border-radius: 8px;
        }

        .receipt table {
          width: 100%;
          border-collapse: collapse; 
        }

        .receipt__text__center {
          text-align: center;
          width: 100%;
        }

        .receipt__separator {
          margin: 5px 0;
          border-top: 1px dashed #000;
          height: 1px;
        }

        .receipt__table td,
        .receipt__table th {
          font-size: 10px;
          font-stretch: condensed;
        }

        .receipt__table__cell,
        .receipt__table__header {
          text-align: left;
          vertical-align: middle;
        }

        .text__ellipsis {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }

        .text__ellipsis.w__ellipsis__small {
          max-width: 10px;
        }

        .text__ellipsis.w__ellipsis__medium {
          max-width: 60px;
        }

        .text__ellipsis.w__ellipsis__large {
          max-width: 100px;
        }

        .text__bold {
          font-weight: bold;
        }

        .receipt__table__cell__right,
        .receipt__table__header__right {
          overflow: hidden;
          text-align: right;
          font-size: 10px;
        }

        .receipt__table__title {
          font-weight: bold;
          font-size: 10px;
          text-align: center;
        }

        .receipt__fecha__validacion__fe{
          display: flex;
          justify-content: space-between;
        }

        @page {
          size: 80mm 400mm;
          margin: 0;
        }
      }
    </style>
`